import type {FC} from 'react';
import type {FormRequest} from 'src/api/ProactApiClient';
import {PendingSyncBanner} from 'src/offline/PendingSyncBanner';
import type {PendingSyncBannerCopy} from 'src/offline/PendingSyncBanner';
import type {OutboxItem} from 'src/offline/types';
import {discardFormSubmission, retryFormSubmission} from './outboxActions';
import {usePendingFormSubmissions} from './usePendingFormSubmissions';

const submissionLabel = (item: OutboxItem): string =>
  (item.payload as FormRequest).shortDescription || 'Form submission';

const COPY: PendingSyncBannerCopy = {
  noun: 'form submission',
  nounPlural: 'form submissions',
  offlineTail:
    'They will be submitted automatically when you are back online.',
  discardTitle: 'Discard this submission?',
  discardBodyTail: 'it will not be submitted.',
  discardConfirmLabel: 'Discard submission',
};

// Shown on the forms list surfaces while form submissions sit unsynced.
export const FormsPendingSyncBanner: FC = () => {
  const {pendingCount, failedItems} = usePendingFormSubmissions();

  return (
    <PendingSyncBanner
      pendingCount={pendingCount}
      failedItems={failedItems}
      itemLabel={submissionLabel}
      onRetry={retryFormSubmission}
      onDiscard={discardFormSubmission}
      copy={COPY}
    />
  );
};
